import { SkinnableComponent, ComponentSkinProps } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useCompanyHistoryLogic } from './CompanyHistoryLogic';
import BasicCompanyHistorySkin from './skins/BasicCompanyHistorySkin';

/**
 * CompanyHistory 컴포넌트의 스킨 시스템 정의
 */
export const CompanyHistorySkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.COMPANY_HISTORY,
  name: '회사 연혁',
  category: 'content',
  icon: '📅',
  options: [
    {
      type: 'text',
      label: '제목',
      key: 'title',
      default: '회사 연혁'
    },
    {
      type: 'text',
      label: '부제목',
      key: 'subtitle',
      default: ''
    },
    {
      type: 'select',
      label: '타임라인 스타일',
      key: 'timelineStyle',
      options: [
        { value: 'vertical', label: '수직형' },
        { value: 'horizontal', label: '수평형' }
      ],
      default: 'vertical'
    },
    {
      type: 'checkbox',
      label: '애니메이션',
      key: 'animation',
      default: true
    },
    {
      type: 'number',
      label: '이미지 너비',
      key: 'imageWidth',
      default: 150,
      min: 50,
      max: 300
    },
    {
      type: 'number',
      label: '이미지 높이',
      key: 'imageHeight',
      default: 150,
      min: 50,
      max: 300
    },
    {
      type: 'color',
      label: '주 색상',
      key: 'primaryColor',
      default: '#3498db'
    },
    {
      type: 'color',
      label: '보조 색상',
      key: 'secondaryColor',
      default: '#f1c40f'
    },
    {
      type: 'color',
      label: '배경색',
      key: 'backgroundColor',
      default: '#ffffff'
    },
    {
      type: 'color',
      label: '텍스트 색상',
      key: 'textColor',
      default: '#333333'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicCompanyHistorySkin as any
  },
  useLogic: useCompanyHistoryLogic as any,
  defaultProps: {
    title: '회사 연혁',
    subtitle: '',
    timelineStyle: 'vertical',
    colorScheme: {
      primary: '#3498db',
      secondary: '#f1c40f',
      background: '#ffffff',
      text: '#333333'
    },
    animation: true,
    imageWidth: 150,
    imageHeight: 150,
    historyItems: [
      {
        id: '1',
        year: '2020',
        title: '회사 설립',
        description: '혁신적인 비전을 가지고 회사를 설립했습니다.',
        image: 'https://via.placeholder.com/150'
      },
      {
        id: '2',
        year: '2021',
        title: '첫 제품 출시',
        description: '고객의 니즈를 반영한 첫 제품을 성공적으로 출시했습니다.',
        image: 'https://via.placeholder.com/150'
      },
      {
        id: '3',
        year: '2022',
        title: '글로벌 진출',
        description: '해외 시장에 성공적으로 진출하여 글로벌 기업으로 도약했습니다.',
        image: 'https://via.placeholder.com/150'
      }
    ]
  }
};